<template lang="pug">
	.container-fluid
		listado-filtro(:filtro="filtro" @buscar="buscar" @nuevo="idCliente = 'nuevo'")
		.card.text-left.mt-2(v-if="resultados.length > 0")
			.card-header
				span.fa.fa-list.mr-2
				| {{ resultados.length }} resultados
			.table-responsive.text-left
				table.table.table-striped.table-condensed.m-0
					thead.bg-dark.text-white
						tr
							th ID
							th Agente
							th Cliente
							th Creación
							th CIF
							th Facturado
							th Semáforo contratos
							th Semáforo propuestas
							th Opciones
					tbody
						tr(v-for="cliente in resultados" :key="cliente.ID_cliente")
							td {{ cliente.ID }}
							td
								span(v-if="cliente.agenteID") {{ cliente.agenteNombre }}
								span.text-danger(v-else)
									span.fa.fa-user-times
							td(:class="!cliente.activo ? 'text-danger' : ''")
								span.text-danger.mr-2(v-if="!cliente.activo")
									.fa.fa-window-close-o
								span {{ cliente.cliente }}
								span.ml-2.text-primary(v-if="cliente.nombre_comercial") ({{cliente.nombre_comercial}})
							td {{cliente.fecha_creacion | moment('DD-MM-YYYY')}}
							td {{ cliente.CIF }}
							td(v-if="cliente.agenteID === usuario.ID || permisos.clientes_verTodos") {{ cliente.importe_facturado | currency('€')}}
							td(v-else)
							td(:class="cliente.color")
								span(v-if="typeof cliente.dias_sin_campana === 'number' && (cliente.agenteID === usuario.ID || permisos.clientes_verTodos)") {{ cliente.dias_sin_campana }} días
								span(v-else, style="opacity:0.4") Nunca
							td(:class="cliente.colorPropuesta")
								span(v-if="typeof cliente.dias_sin_contacto === 'number' && (cliente.agenteID === usuario.ID || permisos.clientes_verTodos)") {{ cliente.dias_sin_contacto }} días
								span(v-else, style="opacity:0.4") Nunca
							td
								button(v-if="cliente.agenteID === usuario.ID || permisos.clientes_verTodos" class="btn btn-sm btn-primary" @click="idCliente = cliente.ID")
									span.fa.fa-eye
		div(v-if="resultados.length === 0" style="text-align:center;padding-top:20px;font-size:2em;font-weight:bold;" class="text-danger")
			span.fa.fa-ban
			br
			| No hay resultados
		editor-cliente(:id-cliente="idCliente" v-if="idCliente" @cerrar="cierraEditor()")
</template>


<script>
import { mapGetters } from 'vuex'
import Filtro from './listado-filtro'
import Editor from '../editor/editor'
import API from '../../services/api'

export default {
	components: {
		'listado-filtro': Filtro,
		'editor-cliente': Editor
	},
	data: function () {
		return {
			filtro: {
				semaforoContratos: null,
				semaforoPropuestas: null,
				agente: '',
				nombre: '',
				activo: true,
				asignado: true,
				facturacion: null,
				max: 50,
				Google: null,
				ordenarCampo: 'cliente.cliente',
				ordenarOrden: 'ASC'
			},
			resultados: [],
			idCliente: null
		}
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		})
	},
	methods: {
		buscar () {
			API.buscar(this.filtro)
				.then(res => {
					// procesamos el color del semaforo
					res.data.resultados = res.data.resultados.map(r => {
						if (typeof r.dias_sin_campana !== 'number') {
							r.color = 'semaforoRojo'
						} else {
							if (r.dias_sin_campana <= 150) {
								r.color = 'semaforoVerde' // Verde
							} else if (r.dias_sin_campana <= 300) {
								r.color = 'semaforoAmarillo' // Naranja
							} else {
								r.color = 'semaforoRojo'
							}
						}

						if (typeof r.dias_sin_contacto !== 'number') {
							r.colorPropuesta = 'semaforoRojo'
						} else {
							if (r.dias_sin_contacto <= 150) {
								r.colorPropuesta = 'semaforoVerde'
							} else if (r.dias_sin_contacto <= 300) {
								r.colorPropuesta = 'semaforoAmarillo'
							} else {
								r.colorPropuesta = 'semaforoRojo'
							}
						}

						return r
					})
					this.resultados = res.data.resultados
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		cierraEditor () {
			this.idCliente = null
			this.buscar()
		}
	}
}
</script>


<style scoped>
.semaforoVerde {
	background-color: #dfffd6;
}

.semaforoAmarillo {
	background-color: #ffe3ba;
}

.semaforoRojo {
	background-color: #fab1aa;
}
</style>



// WEBPACK FOOTER //
// src/modulos/gestion-clientes/vue/components/listado/listado.vue